<template>
  <Content id="developStandardManage-list" style="margin-left: 10px;">
    <div class="ivu-col ivu-col-span-xs-24 ivu-col-span-sm-24 ivu-col-span-md-24 ivu-col-span-lg-24">
      <h2 slot="title" style="text-align: center">{{ titleData[currentRowIndex] }}</h2>
    </div>

    <el-table ref="table" stripe :data="listData" highlight-current-row highlight-selection-row
              :max-height="tableHeight1" :border="true" header-align="center" style="width: 100%" v-show="type!==3">
      <el-table-column align="center" prop="monthYear" label="岁:月" show-overflow-tooltip/>
      <el-table-column align="center" prop="down3sd" label="-3SD" show-overflow-tooltip/>
      <el-table-column align="center" prop="down2sd" label="-2SD" show-overflow-tooltip/>
      <el-table-column align="center" prop="down1sd" label="-1SD" show-overflow-tooltip/>
      <el-table-column align="center" prop="median" label="中" show-overflow-tooltip/>
      <el-table-column align="center" prop="up1sd" label="+1SD" show-overflow-tooltip/>
      <el-table-column align="center" prop="up2sd" label="+2SD" show-overflow-tooltip/>
      <el-table-column align="center" prop="up3sd" label="+3SD" show-overflow-tooltip/>
    </el-table>

    <el-table ref="table" stripe :data="listData" highlight-current-row highlight-selection-row
              :max-height="tableHeight2" :border="true" header-align="center" style="width: 100%" v-show="type===3">
      <el-table-column align="center" prop="height" label="身高(cm)" show-overflow-tooltip/>
      <el-table-column align="center" label="体重(kg)">
        <el-table-column align="center" prop="down3sd" label="-3SD" show-overflow-tooltip/>
        <el-table-column align="center" prop="down2sd" label="-2SD" show-overflow-tooltip/>
        <el-table-column align="center" prop="down1sd" label="-1SD" show-overflow-tooltip/>
        <el-table-column align="center" prop="median" label="中" show-overflow-tooltip/>
        <el-table-column align="center" prop="up1sd" label="+1SD" show-overflow-tooltip/>
        <el-table-column align="center" prop="up2sd" label="+2SD" show-overflow-tooltip/>
        <el-table-column align="center" prop="up3sd" label="+3SD" show-overflow-tooltip/>
      </el-table-column>
    </el-table>
  </Content>
</template>
<script>
import {_list} from "@/services/screeningConfig/developStandardManagement";
export default {
  name: "DevelopStandardManageList",
  props: {
    currentRowIndex:{
      type: Number,
      default:-1
    },
    type:{
      type: Number,
      default:-1
    },
    sex:{
      type: Number,
      default:-1
    },
    standard:{
      type: Number,
      default:-1
    },
  },
  data() {
    return {
      tableHeight1: window.innerHeight - 200,
      tableHeight2: window.innerHeight - 200,
      listData:[],
      titleData: [
        "0-8岁 WHO男童年龄体重标准","0-8岁 国标男童年龄体重标准",
        "0-8岁 WHO男童年龄身长标准","0-8岁 国标男童年龄身长标准",
        "0-8岁 WHO男童身高体重标准","0-8岁 国标男童身高体重标准",
        "0-8岁 WHO女童年龄体重标准","0-8岁 国标女童年龄体重标准",
        "0-8岁 WHO女童年龄身长标准","0-8岁 国标女童年龄身长标准",
        "0-8岁 WHO女童身高体重标准","0-8岁 国标女童身高体重标准"
      ],
    };
  },
  watch:{
    currentRowIndex:{
      handler(newData, oldData) {
        this.loadList(this.type,this.sex,this.standard);
        this.$refs.table.doLayout();
      },
    },
    type:{
      handler(newData, oldData) {
        if(newData && newData ===3){
          const height = window.innerHeight || document.documentElement.clientHeight;
          this.tableHeight2 = `${height - 200}px`;
        }else{
          const height = window.innerHeight || document.documentElement.clientHeight;
          this.tableHeight1 = `${height - 200}px`;
        }
      },
    },
  },
  computed: {
    getClass() {
      const width = window.innerWidth;
      if (width < 600) {
        return 'small-screen';
      } else if (width < 1200) {
        return 'medium-screen';
      } else {
        return 'large-screen';
      }
    }
  },
  mounted() {
    this.setDynamicHeight();
    if (this.$userSession.checkInstitutionId()) {
      this.loadList(this.type,this.sex,this.standard);
    }
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      if(this.type && this.type ===3){
        this.tableHeight2 = `${height - 200}px`;
      }else{
        this.tableHeight1 = `${height - 200}px`;
      }
    },
    loadList(type,sex,standard){
      this.listData = [];
      if (!this.$userSession.checkInstitutionId()) {
        return;
      }

      _list({type:type,sex:sex,standard:standard}).then(res=>{
        if (res.errcode === 1){
          this.listData= Object.assign([], res.data);
        }
      }).catch(e=>{
        this.listData = [];
      })
    },
  }
};
</script>
<style lang="postcss" scoped>
.small-screen {
  height: 110vh;
}

.medium-screen {
  height: 90vh;
}

.large-screen {
  height: 70vh;
}
</style>
